import {classNames} from "shared/lib/classNames/classNames";
import cls from "./AppImg.module.scss";
import {Link} from "react-router-dom";
import {forwardRef, useState} from "react";

export enum AppSize {
    M = "size_m",
    L = "size_l",
}

interface AppImgProps {
    className?: string;
    size?: AppSize;
    href: string;
    imgSrc: string;
}

const AppImg = forwardRef<HTMLAnchorElement, AppImgProps>((props, ref) => {
    const {className, href, imgSrc, size} = props;
    return (
        <Link ref={ref} to={`/`} className={classNames(cls.AppImg, {}, [className, size ? cls[size] : undefined])}>
            <img
                src={imgSrc}
                alt="app image"
                className={classNames(cls.AppImg__img, {}, [])}
            />
        </Link>
    )
})

export default AppImg;

